module.exports = __webpack_public_path__ + "img/iconSet-03.d442560f.png";